"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slice = void 0;
/**
 * @deprecated Use {@link Reader} instead.
 */
class Slice {
    constructor(uint8, view, start, end) {
        this.uint8 = uint8;
        this.view = view;
        this.start = start;
        this.end = end;
    }
    subarray() {
        return this.uint8.subarray(this.start, this.end);
    }
}
exports.Slice = Slice;
